/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementGenerateSharedPreviewUrlResponse } from './EventManagementGenerateSharedPreviewUrlResponse';

export type EventManagementGenerateSharedPreviewUrlResponseApiRespoonse = {
    data?: EventManagementGenerateSharedPreviewUrlResponse;
    status?: EventManagementGenerateSharedPreviewUrlResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementGenerateSharedPreviewUrlResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

